(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-car-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-bo-car-play]');
  if(!button)return;
  var media=button.closest('[data-bo-car-media]');
  if(!media)return;
  var video=media.querySelector('video');
  if(!video)return;
  video.controls=true;
  var playPromise=video.play();
  if(playPromise&&typeof playPromise.catch==='function'){playPromise.catch(function(){});}
  button.hidden=true;
});

  } catch(e) { console.error(e); }
})();
})();
